import type { FooterCopy } from './footer-en';
import { appLoginUrl } from '@/config/appLinks';

export const FOOTER_AR: FooterCopy = {
  columns: [
    {
      head: 'المنتج',
      links: [
        { label: 'الباقات',         href: '/pricing' },
        { label: 'الثقة',           href: '/trust' },
        { label: 'حالة النظام',      href: 'https://status.prinotes.com/', external: true, live: true },
        /* Built from appLinks, not hardcoded — see the note in footer-en.ts. */
        { label: 'تسجيل الدخول',    href: appLoginUrl('ar'), external: true, live: true },
      ],
    },
    {
      head: 'الشركة',
      links: [
        { label: 'الدعم',          href: 'mailto:support@prinotes.com', live: true },
        { label: 'عن برَينوتس',     href: '/about', live: true },
      ],
    },
    {
      head: 'مركز الثقة',
      links: [
        { label: 'سياسة الخصوصية',  href: '/privacy', live: true },
        { label: 'شروط الخدمة',     href: '/terms', live: true },
        { label: 'مزودو الخدمات',   href: '/subprocessors', live: true },
        { label: 'إدارة ملفات الارتباط', href: '#manage-cookies', opensModal: true },
      ],
    },
    {
      head: 'تواصل',
      links: [
        { label: 'لينكدإن',  href: 'https://www.linkedin.com/company/prinotes', external: true },
        { label: 'إنستغرام', href: 'https://www.instagram.com/prinotes',         external: true },
        { label: 'إكس',      href: 'https://x.com/prinotes',                     external: true },
      ],
    },
  ],
  copyright: '© برَينوتس 2026 · جميع الحقوق محفوظة · تابعة لـ شركة برييورا ذ.م.م',
};
